import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import './index.css';
import App from './App';
import { queryInvalidationService } from './services/QueryInvalidationService';
import { createEnhancedQueryClient, setupOnlineInvalidation } from './services/QueryErrorService';
import { apiClient } from './api';

// Import i18n configuration
import './i18n/i18n';

// Ensure API singleton is initialized at app startup.
void apiClient;

// Create enhanced query client with global error handling
const queryClient = createEnhancedQueryClient();

// Set up the query client for the invalidation service
queryInvalidationService.setQueryClient(queryClient);

// Set up automatic query invalidation when backend comes back online
setupOnlineInvalidation(queryClient);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);
